import React, { Component } from "react";
import Popup from "./Popup";
import { TempDataActions } from "@my-dld/actions";
import { dispatch } from "@my-dld/utils/StoreUtils";

interface Props {
	message: string;
	isError: boolean;
}

class MessagePopup extends Component<Props> {
	onDismiss = () => {
		dispatch( ( this.props.isError ? TempDataActions.SHOW_ERROR : TempDataActions.HIDE_MESSAGE ) );
	};

	render() {
		const { message, isError } = this.props;
		const messageText = message ? message.toString() : undefined;
		return (
			<Popup autoOpenMount={ true } id={ "messagePopUpx" } showCloseButton={ true } onDismiss={ this.onDismiss }>
                <p className={isError ? "text-center" : "text-center" } style={ { whiteSpace: "pre-wrap" } }>
					{ messageText }
				</p>
			</Popup>
		);
	}
}

export default MessagePopup;
